import { useCallback, useEffect, useState } from "react";
import { profileService } from "../services/apiService";

export function useProfile({ auto = true, initialData = null } = {}) {
  const [profile, setProfile] = useState(initialData);
  const [loading, setLoading] = useState(auto && !initialData);
  const [error, setError] = useState(null);

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await profileService.getProfile();
      setProfile(data);
      return data;
    } catch (e) {
      setError(e.message || "Failed to load profile");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (auto && !initialData) {
      fetchProfile();
    }
  }, [auto, initialData, fetchProfile]);

  return { profile, loading, error, fetchProfile, setProfile };
}
